<div class="main-box " [draggable]="!isInPhantomRoute" [class.main-box--box-is-dragged]="isOrderDragged"
    [class.main-box--border-active]="!isEmbeddedInRoute" (dragstart)="dragIsStarting($event)"
    [draggable]="isDragAllowed" [class.main-box--stripes-diagonal]="route?.InformationSentToDriverOutdated"
    (dragend)="dragEnded($event)" (dblclick)="editClick()" (contextmenu)="contextClick($event)">


    <div class="main-box__inner-box flexContent flexColumn align-stretch">
        <div *ngIf="showDateSection" class="main-box--text-overflow-ellipsis text-align-center">
            {{ order.StartDate | date: 'dd.MM.yyyy HH:mm'}}
        </div>

        <div class="main-box--break-line flexContent align-center gap-2">
            <delivery-type-icon [taskType]="order.StartTaskType" />
            <div class="flex-grow flexContent flexColumn">
                <div class="main-box--text-overflow-ellipsis" [matTooltip]=" order.StartPointName"> {{
                    order.StartPointName }}</div>
                <div class="main-box--text-overflow-ellipsis main-box--secondary-info" [matTooltip]="order.StartAddress"
                    *ngIf="order.StartAddress; else emptyAddressBox">
                    {{ order.StartAddress }}
                </div>
            </div>
            <div class="main-box__status-circle" *ngIf="showStatusSection" [style.background-color]="statusColor"
                [matTooltip]="this.order.StatusDictionary?.Title"></div>
        </div>

        <div class="main-box--break-line flexContent align-center gap-2">
            <delivery-type-icon [taskType]="order.EndTaskType" />
            <div class="flex-grow flexContent flexColumn">
                <div class="main-box--text-overflow-ellipsis " [matTooltip]="order.EndPointName"> {{ order.EndPointName
                    }}</div>
                <div class="main-box--text-overflow-ellipsis main-box--secondary-info" [matTooltip]="order.EndAddress"
                    *ngIf="order.EndAddress; else emptyAddressBox"> {{ order.EndAddress }} </div>
            </div>
        </div>
        <div class="main-box--text-overflow-ellipsis">Waga: {{ order.Weight || '0' }}</div>
    </div>
    <div class="main-box__comments-box main-box--text-overflow-ellipsis" [matTooltip]="order.Comments"
        *ngIf="order.Comments">{{ order.Comments }}
    </div>
    <div #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="menu"></div>
</div>
<ng-template #emptyAddressBox>
    <div class="main-box--secondary-info">&nbsp;</div>
</ng-template>

<mat-menu #menu="matMenu" xPosition="before">

    <ng-container *ngIf="isShipment">
        <ng-container *hasPermission="ROOT_SCOPE_VARIABLES.PERMISSIONS.PLANNING_DAILYPLAN.PLANNING.SHOWSHIPMENT">
            <button type="button" mat-menu-item (click)="editClick()">
                <mat-icon>edit</mat-icon>
                <span>Edytuj Zlecenie</span>
            </button>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="!isShipment">
        <ng-container *hasPermission="ROOT_SCOPE_VARIABLES.PERMISSIONS.PLANNING_DAILYPLAN.PLANNING.SHOWORDER">
            <button type="button" mat-menu-item (click)="editClick()">
                <mat-icon>edit</mat-icon>
                <span>Edytuj Zgłoszenie</span>
            </button>
        </ng-container>
    </ng-container>

    <ng-container *ngIf="route">
        <ng-container *hasPermission="ROOT_SCOPE_VARIABLES.PERMISSIONS.PLANNING_DAILYPLAN.PLANNING.TASKORDER">
            <button *ngIf="route" type="button" mat-menu-item (click)="editRouteClick()">
                <mat-icon>route</mat-icon>
                <span>Edytuj Trase</span>
            </button>
        </ng-container>

        <ng-container *hasPermission="ROOT_SCOPE_VARIABLES.PERMISSIONS.PLANNING_DAILYPLAN.PLANNING.FINISH">
            <button *ngIf="route" type="button" mat-menu-item (click)="sendRouteToDriverClick()">
                <mat-icon>sync</mat-icon>
                <span>Wyślij trasę do kierowcy</span>
            </button>
        </ng-container>


        <ng-container *hasPermission="[PERM.EDIT, PERM.MODULE]">
            <div class="divider-wrapper">
                <mat-divider class="divider-color-secondary"></mat-divider>
            </div>
        </ng-container>

        <ng-container *hasPermission="[PERM.ACCESS.TODRIVERS, PERM.EDIT, PERM.MODULE]">
            <button *ngIf="driver" type="button" mat-menu-item
                (click)="onAddAbsenceClick(businessObjectType.DRIVER, driver.driverId)">
                <mat-icon>person_alert</mat-icon>
                <span>Dodaj niedostępność dla kierowcy</span>
            </button>
        </ng-container>

        <ng-container *hasPermission="[PERM.ACCESS.TOVEHICLES, PERM.EDIT, PERM.MODULE]">
            <button *ngIf="driver" type="button" mat-menu-item
                (click)="onAddAbsenceClick(businessObjectType.VEHICLE, driver.vehicleId)">
                <mat-icon>directions_bus</mat-icon>
                <span>Dodaj niedostępność dla pojazdu</span>
            </button>
        </ng-container>

        <ng-container *hasPermission="[PERM.ACCESS.TOVEHICLES, PERM.EDIT, PERM.MODULE]">
            <button *ngIf="driver && driver.trailerId" type="button" mat-menu-item
                (click)="onAddAbsenceClick(businessObjectType.VEHICLE, driver.trailerId)">
                <mat-icon>rv_hookup</mat-icon>
                <span>Dodaj niedostępność dla przyczepy</span>
            </button>
        </ng-container>

    </ng-container>


    <button *ngIf="day?.isInvalid" type="button" mat-menu-item (click)="showConflictsClick()">
        <mat-icon>bus_alert</mat-icon>
        <span>Pokaż konflikty</span>
    </button>
</mat-menu>